/**
 * created by li si yi
 * 媒体备案申请待办处理
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import NewMediaManage from "../../../../newMediaMatrix/pms/newMediaManagement/NewMediaManage";
import BaseComponent from "../../../../../base/BaseComponent";
import {message} from "../../../../sysManagement/utils/sysManagementUtils";

class MediaAudit extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};

    isSupport(data) {
        this.data = data;
        // console.log('媒体备案申请*------', data);
        if (this.data && this.data.data && this.data.data.id && this.data.activitiCategoryKey === "mediaAudit") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'MediaIcon';
        return icon
    };
    //刷新回调
    handle = (data, call) => {
        this.newMediaManage && this.newMediaManage.getById(data.data, (res) => {
            if (res === false) {
                message.error('媒体已删除!');
            } else {
                call && call();
            }
        });
    };

    render() {
        return (
            <div style={{display: 'none'}}>
                <NewMediaManage ref={ref => this.newMediaManage = ref}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(MediaAudit)